import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { loadCustomer, setCustomer } from 'store/slices/customerSlice';
import { mapCustomerData } from '../services/CustomerService';
import { useFormSubmit } from './useFormSubmit';

export const useFetchCustomer = () => {
	const dispatch = useAppDispatch();
	const customer = useAppSelector((state) => state.customer);
	const { onSubmit } = useFormSubmit();

	useEffect(() => {
		const call = async () => {
			if (!customer.isDataFetched && !customer.loading) {
				const authResult = await dispatch(loadCustomer());
				if (authResult.meta.requestStatus === 'fulfilled') {
					dispatch(setCustomer(authResult.payload));
					await mapCustomerData(onSubmit);
				}
			}
		};
		call();
	}, [customer.isDataFetched]);
};
